module.exports = __webpack_public_path__ + "media/aligator_k.787db3b0.mp3";